import React from 'react';
import { cn } from '../../utils/cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, id, ...props }, ref) => {
    const inputId = id || props.name;

    return (
      <div className="app-field">
        {label ? (
          <label htmlFor={inputId} className="app-field__label">
            {label}
            {props.required ? <span className="text-red-500 ml-0.5">*</span> : null}
          </label>
        ) : null}
        <input
          ref={ref}
          id={inputId}
          className={cn('app-input', error && 'is-invalid', className)}
          {...props}
        />
        {error ? <p className="app-field__error">{error}</p> : null}
      </div>
    );
  }
);

Input.displayName = 'Input';
